
import axios from "../../axios";
import { useMutation, useQuery } from "react-query";
import { route } from "./routes";
import { message } from "antd";



// get customer by id 
export function useCustomerById(id) {
  return useQuery([route.CUSTOMER_DETAILS_BY_ID, id], async () => {
    const { data } = await axios.get(`${route.CUSTOMER_DETAILS_BY_ID}${id}`);
    return data;
  }, {
    enabled: id ? true : false
  })
}



// update product to campaign
export function useAddNewCustomer() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(route.ADD_NEW_CUSTOMER, payload);
    return data;
  }, {
    onSuccess: () => {
      // 
    },
    onError: (err) => {
      message.error(err?.message);
    }
  })
}


// get total spending amount
export function useSpendingAmount({ id }) {
  return useQuery([route.CUSTOMER_SPENDING_AMOUNT, id], async () => {
    const { data } = await axios.get(route.CUSTOMER_SPENDING_AMOUNT, {
      params: {
        id
      }
    });
    return data;
  }, {
    enabled: id ? true : false
  })
}



// get customer list

export function useCustomerList({ page, limit, search, status }) {
  const payload = { page, limit, search, status };
  return useQuery(['customer-list', page, limit, search, status], async () => {
    const { data } = await axios.get(route.CUSTOMER_LIST, {
      params: payload
    });
    return data;
  })
}